export const state = {
  loader: false,
  resetPasswordEmail: "",
  isUserEmailVerified: false,
}
